/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Button } from './Button';
import './LSabout.css';
import { Link } from 'react-router-dom';

function LSabout() {
    const [button, setButton] = useState(true);
        
    const showButton = () => {
        if(window.innerWidth <= 960) {
            setButton(false);
        } else {
            setButton(true);
        }
    };
    
    useEffect ( ( ) => {
        showButton();
    }, []);

    window.addEventListener('resize', showButton);

    return (
        <div className = 'lsabout'>
            <div className = 'lsabout-container'>
				<div className = 'lsaboutcol-full'>
                    <Link exact to="/Projects"><p>< img src="../Arrow2_One5Digital.png" alt="Loading..." /> BACK TO PROJECTS</p></Link>
                    <h1>LANGYS</h1>
                </div>
                <div className = 'lsaboutcol-left'>
                    <h3>ABOUT CLIENT</h3>
                    <p className = 'lsabout-desc'>Langys is an established business that supplies Quality Tools and Equipment to Bricklayers, Concreters and Plasterers amongst other trades.
                    Langys  manufactures in house adjustable  Steel Trestles,(tested to AS1170)  Pudlogs, A-Frames, Profile Clamps,  Profile steady, adjustable profiles and Posthole cleaners.</p>
                    <h3>SERVICE</h3>
                    <div className="ser-wrapper">
                        <ul className="ser-1">
                            <li>Digital Strategy</li>
                            <li>Web Design</li>
                            <li>Branding</li>
                        </ul>
                        <ul className="ser-2">
                            <li>Development</li>
                            <li>User Experience</li>
                            <li>Enterprise UX</li>
                        </ul>
                    </div>
                    <h3 className="year">YEAR</h3>
                    <p>2022</p>
                    <div className='lsabout-btn'>
                        <a href="https://langys.com.au/" target="blank">
                            <Button className='btn' buttonStyle='btn--primary'>Visit Website</Button>
                        </a>
                    </div>
                </div>
                <div className="lsaboutcol-right">
                    <img className="lsimg" src= "./LangysAbout_One5Digital.png" alt= "Loading..." />
                    <img className="lsimg2" src= "./LangysAbout_One5Digital.png" alt= "Loading..." />
                </div>
            </div>
        </div>
    )
}

export default LSabout